import logo from "./logo.svg";
import "./App.css";
import Dashboard from "./dashboard/Dashboard";
import Login from "./components/Login/Login";
import { Routes, Route, Navigate } from "react-router";
import { useState } from "react";
import { useSelector } from "react-redux";
import LogOut from "./components/LogOut";

const ProtectedRoute = ({ isAuthenticated, children }) => {
	if (!isAuthenticated) {
		localStorage.setItem("profile", null);
		return <Navigate to="/" replace />;
	}
	return children;
};

function App() {
	const [isAuthenticated, setIsAuthenticated] = useState(useSelector((state) => state.auth.isAuthenticate));
	return (
		<Routes>
			<Route path="/" element={<Login setIsAuthenticated={setIsAuthenticated} />} />
			<Route
				path="/admin"
				element={
					<ProtectedRoute isAuthenticated={isAuthenticated}>
						<Dashboard isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} option={1} />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/withdrawal/:crypto/:net"
				element={
					<ProtectedRoute isAuthenticated={isAuthenticated}>
						<Dashboard isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} option={2} />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/security"
				element={
					<ProtectedRoute isAuthenticated={isAuthenticated}>
						<Dashboard isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} option={3} />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/changepassword"
				element={
					<ProtectedRoute isAuthenticated={isAuthenticated}>
						<Dashboard isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} option={4} />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/reports"
				element={
					<ProtectedRoute isAuthenticated={isAuthenticated}>
						<Dashboard isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} option={5} />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/reports/customerdeposits"
				element={
					<ProtectedRoute isAuthenticated={isAuthenticated}>
						<Dashboard isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} option={6} />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/reports/customerwithdrawals"
				element={
					<ProtectedRoute isAuthenticated={isAuthenticated}>
						<Dashboard isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} option={7} />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/reports/agentwithdrawals"
				element={
					<ProtectedRoute isAuthenticated={isAuthenticated}>
						<Dashboard isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} option={8} />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/customers"
				element={
					<ProtectedRoute isAuthenticated={isAuthenticated}>
						<Dashboard isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} option={9} />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/settings"
				element={
					<ProtectedRoute isAuthenticated={isAuthenticated}>
						<Dashboard isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} option={10} />
					</ProtectedRoute>
				}
			/>
			{/*<Route
				path="/reports/withdrawalsrequest"
				element={
					<ProtectedRoute isAuthenticated={isAuthenticated}>
						<Dashboard isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} option={11} />
					</ProtectedRoute>
				}
			/>*/}
			<Route
				path="/deposit/:crypto/:net"
				element={
					<ProtectedRoute isAuthenticated={isAuthenticated}>
						<Dashboard isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} option={12} />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/reports/agentdeposits"
				element={
					<ProtectedRoute isAuthenticated={isAuthenticated}>
						<Dashboard isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} option={13} />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/agenttransfer/:crypto/:net"
				element={
					<ProtectedRoute isAuthenticated={isAuthenticated}>
						<Dashboard isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} option={14} />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/reports/agenttransfersreport"
				element={
					<ProtectedRoute isAuthenticated={isAuthenticated}>
						<Dashboard isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} option={15} />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/admin/agentslist"
				element={
					<ProtectedRoute isAuthenticated={isAuthenticated}>
						<Dashboard isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} option={16} />
					</ProtectedRoute>
				}
			/>
			<Route path="/logout" element={<LogOut setIsAuthenticated={setIsAuthenticated} />} />
		</Routes>
	);
}

export default App;
